import {useFormContext} from 'react-hook-form'

import {DrillingPosition} from '@refra/modules/refra-planning/types'

interface CheckboxProps {
  x: number
  y: number
  id: number
  labelX: number
  labelY: number
  label: string
}
export const Checkbox = ({id, x, y, labelY, labelX, label}: CheckboxProps) => {
  const {register} = useFormContext<{drillingPositions: DrillingPosition[]}>()

  return (
    <>
      <div
        className="absolute left-[5px]"
        style={{
          left: `${x}px`,
          top: `${y}px`,
          transform: 'translate(-50%, -50%)'
        }}
        data-test-id={`checkbox_${id}`}
      >
        <input type="checkbox" {...register(`drillingPositions.${id}.isEnabled`)} />
      </div>
      <div
        className="absolute flex items-center justify-center transform -scale-x-100"
        style={{
          position: 'absolute',
          left: `${labelX}px`,
          top: `${labelY}px`,
          transform: 'translate(-50%, -50%)'
        }}
      >
        <span className="text-sm text-gray-700" data-test-id={`checkbox_${id}_label`}>
          {label}°
        </span>
      </div>
    </>
  )
}
